import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { adminQueryKeys, Admins } from '#api';
import { makeMaxResourceQueryFn } from '#util/api.ts';

const maxAdminsQueryOptions = queryOptions({
  queryKey: adminQueryKeys.maxList,
  queryFn: makeMaxResourceQueryFn(Admins.getAdmins),
});

export function useSuspenseMaxAdminsQuery() {
  return useSuspenseQuery(maxAdminsQueryOptions);
}
